import { motion } from "motion/react";

interface SuggestionChipsProps {
  suggestions: string[];
  onSelect: (suggestion: string) => void;
  disabled: boolean;
}

export function SuggestionChips({
  suggestions,
  onSelect,
  disabled,
}: SuggestionChipsProps) {
  if (!suggestions || suggestions.length === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: 0.2 }}
      className="flex flex-wrap gap-2 py-3"
    >
      {suggestions.map((suggestion, index) => (
        <motion.button
          key={suggestion}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.25,
            delay: 0.3 + index * 0.08,
            ease: "easeOut",
          }}
          whileHover={{ scale: 1.03, y: -1 }}
          whileTap={{ scale: 0.97 }}
          onClick={() => onSelect(suggestion)}
          disabled={disabled}
          className={`
            px-4 py-2.5 text-sm rounded-xl text-left
            bg-linear-to-br from-stone-50 to-stone-100
            border border-stone-200/80
            text-stone-700 font-medium
            shadow-sm shadow-stone-900/5
            transition-all duration-200
            hover:border-emerald-300 hover:text-emerald-800
            hover:shadow-md hover:shadow-emerald-900/10
            hover:from-emerald-50 hover:to-teal-50
            disabled:opacity-50 disabled:cursor-not-allowed
            disabled:hover:scale-100 disabled:hover:y-0
          `}
        >
          {suggestion}
        </motion.button>
      ))}
    </motion.div>
  );
}
